module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.e31d1018.svg";